import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        modal: {
            position: 'fixed',
            zIndex: 1201,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: 'auto',
            background: 'background.overlay-modal',
            display: 'flex',
            alignContent: 'center',
        },
        content: {
            marginX: {base: `${remCalc(16)}`, lg: 'auto'},
            marginY: {base: remCalc(16), lg: 'auto'},
            borderWidth: remCalc(1),
            borderBottom: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            borderRadius: remCalc(8),
            width: {base: 'auto', lg: remCalc(688)},
            padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            position: 'relative',
            background: 'background.default',
            flexDirection: 'column',
        },
        close: {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
        },
        text: {
            textStyle: 'body-large',
            color: 'text.default',
            borderBottom: 'small',
            borderColor: 'border.dark',
            borderStyle: 'solid',
            paddingBottom: remCalc(16),
            marginBottom: {base: remCalc(16), md: remCalc(24)},
            paddingRight: remCalc(24),
        },
    },
    variants: {
        wishlist: {
            content: {
                padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: remCalc(24)},
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 500,
                color: 'text.default',
                paddingBottom: remCalc(16),
            },
            text: {
                marginBottom: {base: remCalc(24), lg: remCalc(40)},
            },
        },
        native: {
            '.gigya-screen-dialog.gigya-style-modern': {
                width: '100%',
                left: '0 !important',
                display: 'flex',
                justifyContent: 'center',
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-main': {
                width: '94%',
                maxWidth: remCalc(688),
                padding: `${remCalc(24)} ${remCalc(16)}`,
                background: '#ffffff',
                borderRadius: remCalc(8),
                textStyle: 'body-medium',
                boxShadow: 'none',
            },
            '.gigya-screen-dialog.gigya-style-modern .dlg-screen-dialog-main .gigya-screen-dialog-top':
                {
                    display: 'none',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-top': {
                padding: `0 0 ${remCalc(16)}`,
                background: '#ffffff',
                borderBottom: `${remCalc(1)} solid #000000`,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: remCalc(24),
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-top .gigya-screen-dialog-caption':
                {
                    color: '#000000',
                    fontSize: remCalc(18),
                    lineHeight: remCalc(22),
                    fontFamily: 'inherit',
                },
            '.gigya-style-modern div.gigya-screen-dialog-close > a': {
                display: 'flex',
                padding: remCalc(0),
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form':
                {
                    paddingTop: 0,
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-inner .gigya-screen-content form>.gigya-layout-row':
                {
                    display: 'flex',
                    flexDirection: 'column',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-label-text.gigya-composite-control': {
                paddingBottom: remCalc(24),
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-composite-control': {
                position: 'relative',
            },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper input': {
                borderRadius: `${remCalc(4)} !important`,
                border: `${remCalc(1)} solid #636363 !important`,
                color: '#000000',
                fontSize: remCalc(12),
                outline: '0',
                width: '100%',
                lineHeight: remCalc(16),
                backgroundColor: 'transparent !important',
                padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                boxSizing: 'border-box',
                appearance: 'none',
            },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label': {
                lineHeight: '150%',
                display: 'inline-block',
                color: '#636363',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                transformOrigin: '0 0',
                transition:
                    'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
                padding: `0 ${remCalc(4)}`,
                overflow: 'hidden',
                pointerEvents: 'none',
                position: 'absolute',
                top: `calc(50% - ${remCalc(21)})`,
                left: remCalc(8),
                zIndex: '1',
                fontSize: remCalc(12),
                backgroundColor: 'transparent',
            },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.focus-visible)>label, .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-valid)>label, .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper:has(input.gigya-error)>label':
                {
                    backgroundColor: '#ffffff',
                    transform: 'translateY(calc(50% - 23px)) scale(.75)',
                },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label .gigya-label-text':
                {
                    color: '#636363',
                    fontSize: remCalc(14),
                    lineHeight: remCalc(16),
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-error-msg': {
                minHeight: remCalc(24),
                color: '#DE1C2F',
                textAlign: 'left',
            },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper input.gigya-error':
                {
                    padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                    border: `${remCalc(1)} solid #DE1C2F !important`,
                },
            '.gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label:has(~ .gigya-error), .gigya-screen-dialog.gigya-style-modern .dlg-gigya-input-text-wrapper>label:has(~ .gigya-error) *':
                {
                    color: '#DE1C2F',
                },
            '.gigya-screen-dialog.gigya-style-modern .dlg-hidden, .gigya-screen-dialog.gigya-style-modern .gigya-toggle-content':
                {
                    display: 'none',
                },
            '.gigya-screen-dialog.gigya-style-modern .dln-completeForm__paragraph--secondary': {
                fontSize: remCalc(14),
                color: '#636363',
                lineHeight: '125%',
                marginBottom: remCalc(24),
                display: 'inline-block',
            },
            '.gigya-screen-dialog.gigya-style-modern .dln-completeForm__paragraph a, .gigya-screen-dialog.gigya-style-modern .gigya-checkbox-text a':
                {
                    textDecoration: 'underline',
                    color: '#000000',
                    fontWeight: 500,
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-submit, .gigya-screen-dialog.gigya-style-modern .gigya-button-link':
                {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    outlineWidth: 0,
                    fontSize: remCalc(16),
                    lineHeight: remCalc(20),
                    fontWeight: 700,
                    alignItems: 'center',
                    height: remCalc(40),
                    background: '#266BBF',
                    borderRadius: remCalc(100),
                    color: '#ffffff',
                    cursor: 'pointer',
                    marginTop: remCalc(24),
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-button-link button': {
                fontWeight: 700,
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-submit:hover, .gigya-screen-dialog.gigya-style-modern .gigya-button-link:hover':
                {
                    background: '#5589CC',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label:before':
                {
                    position: 'absolute',
                    content: '""',
                    display: 'block',
                    width: remCalc(24),
                    height: remCalc(24),
                    border: `${remCalc(1)} solid #000000`,
                    backgroundColor: 'transparent',
                    borderRadius: remCalc(2),
                    top: 0,
                    left: 0,
                    zIndex: 1,
                    transform: 'none',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label:after':
                {
                    position: 'absolute',
                    display: 'none',
                    content: '""',
                    width: remCalc(7),
                    height: remCalc(15),
                    top: remCalc(3),
                    left: remCalc(9),
                    zIndex: 2,
                    transform: 'rotate(45deg)',
                    border: `${remCalc(1)} solid #000000`,
                    borderTop: 0,
                    borderLeft: 0,
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox:checked+label.gigya-label:after':
                {
                    display: 'block',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox+label.gigya-label': {
                position: 'relative',
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-input-checkbox': {
                display: 'none',
                position: 'relative',
                width: remCalc(24),
                height: remCalc(24),
                flexShrink: 0,
            },
            '.gigya-screen-dialog.gigya-style-modern .gigya-composite-control-checkbox .gigya-checkbox-text':
                {
                    fontSize: remCalc(14),
                    lineHeight: remCalc(16),
                    fontWeight: '400',
                    display: 'block',
                    paddingLeft: remCalc(40),
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-spacer':
                {
                    display: 'none',
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-submit input':
                {
                    marginTop: 0,
                },
            '.gigya-screen-dialog.gigya-style-modern .gigya-resend-verification-code-form .gigya-composite-control-link':
                {
                    marginTop: remCalc(24),
                    fontWeight: 700,
                    textAlign: 'center',
                    color: '#266BBF',
                    textDecoration: 'underline',
                },
            '@media (min-width: 1024px)': {
                '.gigya-screen-dialog.gigya-style-modern .gigya-screen-dialog-main': {
                    padding: `${remCalc(40)} ${remCalc(24)}`,
                },
            },
        },
    },
}
